export default {
  label: {
    sentimentText: 'Sentimento',
  },
};
